export const MODAL_OVERLAY_CLASS_NAME = [
  'bg-black/85',
  'backdrop-blur-md',
].join(' ');

export const MODAL_PANEL_EMPHASIS_CLASS_NAME = [
  'ring-1 ring-white/20',
  'outline outline-1 outline-black/80',
  'shadow-[0_32px_100px_rgba(0,0,0,0.85),0_0_48px_rgba(56,189,248,0.08)]',
].join(' ');
